import { BsToggleOff, BsToggleOn } from "react-icons/bs";
import { generateIcon } from "utils";

interface IBooleanStatusProps {
  value: boolean;
}

export function BooleanStatus({ value }: IBooleanStatusProps): JSX.Element {
  return (
    <span>
      {generateIcon(
        value ? BsToggleOn : BsToggleOff,
        `text-[36px]  ${value ? "text-green" : "text-gray-300"}`
      )}
    </span>
  );
}
